import { LoginFlow, LogoutFlow, Session } from "@ory/client";
import { useEffect, useState } from "react";
import { frontendApi } from "../api/oryApi";
import SignallingServerConnection from "../stores/SignallingServerConnection";
import ImageCaptureStore from "../stores/ImageCaptureStore";


export const useAuth = (signallingStore: SignallingServerConnection, imageCaptureStore: ImageCaptureStore ) => {
  const [session, setSession] = useState<Session | undefined>();
  const [sessionJwt, setSessionJwt] = useState<string | undefined>();
  const [logoutFlow, setLogoutFlow] = useState<LogoutFlow | undefined>();
  const [loginFlow, setLoginFlow] = useState<LoginFlow | undefined>();

  useEffect(() => {
    frontendApi
      .toSession()
      .then(({ data }) => {
        setSession(data);
        frontendApi.createBrowserLogoutFlow().then(({ data: flow }) => {
          setLogoutFlow(flow);
        });
      })
      .then(() =>
        Promise.all([
          frontendApi.toSession({ tokenizeAs: "webrtc" }),
          frontendApi.toSession({ tokenizeAs: "ws_snappi" })
        ])
      )
      .then(([sessionWebrtc, sessionSnappi]) => {
        const jwtWebrtc = sessionWebrtc.data.tokenized;
        const jwtSnappi = sessionSnappi.data.tokenized;
        if (!jwtWebrtc || !jwtSnappi) {
          throw new Error("Missing tokenized session(s)");
        }
        signallingStore.setJwt(jwtWebrtc);
        imageCaptureStore.setJwt(jwtSnappi);
        setSessionJwt(jwtWebrtc);
      })
      .catch(() => {
        frontendApi
          .createBrowserLoginFlow({ returnTo: window.location.toString() })
          .then(({ data: flow }) => {
            setLoginFlow(flow);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }, [signallingStore, imageCaptureStore]);

  const isSessionVivacityAdmin =
    session && session.identity?.traits.email.endsWith("@vivacitylabs.com");

  return {
    session,
    sessionJwt,
    isSessionVivacityAdmin,
    loginFlow,
    logoutFlow,
  };
};
